export default __webpack_public_path__ + "static/media/styled-components-logo-dark-mode.f47c6a86.png";